<template>
	<div :class="'page-component-' + (component || 'unknown').toLowerCase()" class="page-component-wrapper">
		<div class="page-component">
			<h1 v-if="showTitle">{{ title }}</h1>
			<vue-markdown class="text" v-if="text">{{ text }}</vue-markdown>

			<component
					:class="'page-component-' + componentLowerCase + ' side-' + side"
					:is="'PageComponent' + component"
					:options="options"
					:side="side"
					:title="title"
					class="page-component"
					v-on:pickChoice="onPickChoice"
			/>

			<div class="d-flex my-5" v-if="showButtons">
				<app-button class="mr-3" accent="secondary" v-if="showBackButton" v-on:click.native="onClickBack">
					{{$t('misc.back')}}
				</app-button>
				<app-button v-if="showContinueButton" v-on:click.native="onClickContinue">
					{{ continueButtonText }}
				</app-button>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'

	import PageComponentChoices from './choices'
	import PageComponentMedia from './media'
	import PageComponentText from './text'
	import PageComponentResults from './results'

	import AppButton from '@/components/app-button';
	import VueMarkdown from 'vue-markdown';

	export default {
		name: 'page-component',
		components: {
			PageComponentChoices,
			PageComponentMedia,
			PageComponentText,
			PageComponentResults,
			AppButton,
			VueMarkdown
		},
		props: {
			side: {
				type: String,
				required: true
			},
			component: {
				type: String,
				required: true
			},
			title: {
				type: String,
				required: false
			},
			options: {
				type: Object,
				required: false,
				default() {
					return {};
				}
			}
		},
		computed: {
			...mapGetters({
				currentCase: 'getCurrentCase',
				actualCurrentPageIndex: 'getCurrentPageIndex',
			}),

			componentLowerCase() {
				return this.component.toLowerCase();
			},
			showContinueButton() {
				if (!this.isLeftOrFull) {
					return false;
				}

				return this.component != 'Results';
			},
			showBackButton() {
				if (!this.isLeftOrFull || this.actualCurrentPageIndex == 0) {
					return false;
				}

				// Uncomment below to force avoiding going back to choices
				// const prevPage = this.currentCase.pages[this.actualCurrentPageIndex - 1];
				// if (prevPage.components.left.component == 'Choices') {
				// 	return false;
				// }

				return this.currentCase.pages[this.actualCurrentPageIndex].showBackButton;
			},
			showButtons() {
				return this.showContinueButton || this.showBackButton;
			},
			showTitle() {
				return this.isLeftOrFull && this.title;
			},
			isLeftOrFull() {
				return this.side === 'left' || this.side === 'full';
			},
			isLastPage() {
				return this.actualCurrentPageIndex >= this.currentCase.pages.length - 1;
			},
			continueButtonText() {
				return this.isLastPage ? this.$t('misc.finish') : this.$t('misc.continue');
			},
			text() {
				if (this.component === 'Results') {
					return false;
				}

				return this.options && this.options.text ? this.options.text : '';
			}
		},
		methods: {
			emitContinue() {
				if (this.isLastPage) {
					this.$emit('end');
				} else {
					this.$emit('continue');
				}
			},
			onClickContinue() {
				this.emitContinue();
			},
			onClickBack() {
				this.$emit('goBack');
			},
			onPickChoice(choice) {
				this.$emit('pickChoice', choice);
			}
		}
	}
</script>
